import { all, fork } from 'redux-saga/effects';

import watchGetPublications from './getPublications';

function* appSagas() {
  yield all([fork(watchGetPublications)]);
}

export default appSagas;
